var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navbar',{attrs:{"position":"fixed","transparent":_vm.transparent,"color-on-scroll":_vm.colorOnScroll,"menu-classes":"ml-auto"}})}
var staticRenderFns = []

export { render, staticRenderFns }